import React from 'react';
import EditPageDocsGenerateModal from './EditPageDocsGenerateModal';
import FieldSelect from '../fields/FieldSelect';
import * as Row from '../../layout/Row';

export default class EditPageDeliveryDocsGenerateModal extends EditPageDocsGenerateModal {

    constructor(props) {
        super(props)

        this.state = {
            ...this.state,
            languageId: null
        }
    }

    onLanguageChange = item => {
        this.setState({
            languageId: item
        })
    }

    renderBody() {
        const languages = this.state.isLoading ? [] : this.state.model.language.items

        return (
            <React.Fragment>
                <Row.Container hasOuterGutter={false} className="flex-center-v" style={{paddingTop: '1rem'}}>
                    <Row.Column6>
                        <div className="text-muted">{__('Language')}</div>
                    </Row.Column6>
                    <Row.Column6>
                        <FieldSelect
                            items={languages}
                            value={this.state.languageId}
                            onChange={this.onLanguageChange}
                        />
                    </Row.Column6>
                </Row.Container>
            </React.Fragment>
        )
    }

    buildPostModel(configurationEditModel) {
        return {
            id: this.props.id,
            projectId: configurationEditModel.projectId,
            type: 'Delivery',
            language: this.state.languageId,
            configuration: configurationEditModel
        }
    }

    getDocumentType() {
        return 'Delivery';
    }
}